export default {
  // 新增绿色能源
  insertPaGreenEnergy: '/ygsjzs/paGreenEnergy/insertPaGreenEnergy',
  // 修改绿色能源
  updatePaGreenEnergy: '/ygsjzs/paGreenEnergy/updatePaGreenEnergy',
  // 物理删除绿色能源
  deleteDataPaGreenEnergy: '/ygsjzs/paGreenEnergy/deleteDataPaGreenEnergy',
  // 查询绿色能源详情
  selectPaGreenEnergyByEnergyId: '/ygsjzs/paGreenEnergy/selectPaGreenEnergyByEnergyId',
  // 分页查询绿色能源列表
  selectPaGreenEnergyByPage: '/ygsjzs/paGreenEnergy/selectPaGreenEnergyByPage',
  // 导出
  exportPaGreenEnergy: '/ygsjzs/paGreenEnergy/exportPaGreenEnergy'
}
